export const fileStatusDropdownList = [
  { label: '전체', value: 'all' },
  { label: '다운로드 가능', value: 'allow' },
  { label: '다운로드 불가', value: 'deny' },
];
